﻿﻿import { State } from '../enums/index';

export interface IPostalCode {
    code: string;
    latitude: number;
    longitude: number;
    city: string;
    state: string;
    stateEnum: State;
    isInPhlebotomyArea: boolean;
    isInPwlArea: boolean;
}
